// src/pages/CampaignDashboard/modals/ReviewEmailModal.js

import React, { useState, useEffect } from 'react';
import ReactQuill from "react-quill";
import 'quill/dist/quill.snow.css';
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

// Configuration for the Rich Text Editor Toolbar
const modules = {
  toolbar: [
    [{ font: [] }, { size: [] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["blockquote", "code-block"],
    [{ align: [] }],
    ["link", "image"],
    ["clean"],
  ],
};

const ReviewEmailModal = ({ isOpen, initialEmailData, onClose, onUpdate }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [emailData, setEmailData] = useState([]);

  // When the modal opens, load the initial data into the modal's state
  useEffect(() => {
    if (initialEmailData && initialEmailData.length > 0) {
      // Sort data by draft_type to ensure correct order (main, followup 1, etc.)
      const sortedData = [...initialEmailData].sort((a, b) => a.draft_type - b.draft_type);
      setEmailData(sortedData);
      setCurrentIndex(0); // Reset to the first email
    }
  }, [initialEmailData]);

  if (!isOpen || emailData.length === 0) return null;

  const currentEmail = emailData[currentIndex];

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? emailData.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === emailData.length - 1 ? 0 : prev + 1));
  };

  // Update the local state as the user types
  const handleContentChange = (content, field) => {
    const updatedEmails = emailData.map((email, index) =>
      index === currentIndex ? { ...email, [field]: content } : email
    );
    setEmailData(updatedEmails);
  };

  const getTitle = () => {
    const titles = {
      0: "View Email",
      3: "View Final Follow-up Email",
    };
    return titles[currentEmail.draft_type] || "View Follow-up Email";
  };
  
  const handleUpdateClick = () => {
    onUpdate(currentEmail); // Pass the currently edited email back to the parent
  };


  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg md:w-[900px] md:h-[750px]">
        <h3 className="text-xl font-bold mb-4">{getTitle()}</h3>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Subject:</label>
          <input
            type="text"
            value={currentEmail.subject}
            onChange={(e) => handleContentChange(e.target.value, 'subject')}
            className="w-full border border-gray-300 rounded-lg p-2"
          />
        </div>
        
        <div className="mb-[50px]">
          <label className="block text-sm font-medium text-gray-700 my-2">Content:</label>
          <ReactQuill
            theme="snow"
            value={currentEmail.body}
            onChange={(content) => handleContentChange(content, 'body')}
            modules={modules}
            className="md:h-[400px] h-[250px] rounded-lg"
          />
        </div>

        <div className="flex justify-between items-center mb-4">
          <button onClick={handlePrev} className="px-3 py-1 bg-gray-300 rounded-lg flex items-center">
            <FaArrowLeft size={16} className="mr-1" /> Prev
          </button>
          <span>{currentIndex + 1} / {emailData.length}</span>
          <button onClick={handleNext} className="px-3 py-1 bg-gray-300 rounded-lg flex items-center">
            Next <FaArrowRight size={16} className="ml-1" />
          </button>
        </div>

        <div className="flex justify-end space-x-4 mt-[50px]">
          <button onClick={handleUpdateClick} className="px-4 py-2 bg-blue-600 text-white rounded-full">
            Update
          </button>
          <button onClick={onClose} className="px-4 py-2 bg-gray-300 rounded-full">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReviewEmailModal;